// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const OperatingSystemsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 40 28">
    <path
      fill="url(#operating-systems_svga)"
      d="M33.33 24c1.84 0 3.32-1.5 3.32-3.33L36.67 4c0-1.83-1.5-3.33-3.34-3.33H6.67A3.34 3.34 0 0 0 3.33 4v16.67c0 1.83 1.5 3.33 3.34 3.33H0v3.33h40V24zM6.67 4h26.66v16.67H6.67z"
    />
    <defs>
      <linearGradient
        id="operating-systems_svga"
        x1={0}
        x2={25.72}
        y1={0.67}
        y2={37.35}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E45E2" />
        <stop offset={1} stopColor="#A22E95" />
      </linearGradient>
    </defs>
  </svg>,
  "OperatingSystems",
);
export default OperatingSystemsIcon;
